import { Divider, Stack } from "@mui/material";

import { CarrierStatLabel } from "./components/CarrierStatLabel";
import { buildCarrierStats } from "./utils";

import type { SvgIconProps, TypographyProps } from "@mui/material";

import type { CarrierMetadata } from "types/company/carrier";

interface Props {
  carrierMeta: CarrierMetadata;
  withDescription?: boolean;
  // Shows what each figure rests on, as `4.7 (12)`. Only reaches the icon
  // layout: the description layout already spells the count out in words.
  withCounts?: boolean;
  withTrackingLinkSubmissionRate?: boolean;
  iconSize?: SvgIconProps["fontSize"];
  textVariant?: TypographyProps["variant"];
}

export function CarrierStatsRow(props: Props) {
  const {
    carrierMeta,
    withDescription = false,
    withCounts = false,
    withTrackingLinkSubmissionRate = false,
    iconSize = "medium",
    textVariant = "h6",
  } = props;

  const stats = buildCarrierStats({
    carrierMeta,
    withTrackingLinkSubmissionRate,
  });

  return (
    <Stack
      direction="row"
      spacing={1}
      alignItems="center"
      divider={<Divider orientation="vertical" />}
    >
      {stats.map((stat) => (
        <CarrierStatLabel
          key={stat.description}
          {...stat}
          withDescription={withDescription}
          withCounts={withCounts}
          iconSize={iconSize}
          textVariant={textVariant}
        />
      ))}
    </Stack>
  );
}
